import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { createI18n } from 'vue-i18n';
import App from '@/App.vue';
import router from '@/router';
import * as store from '@/store';
import en from '@/i18n/en.json';
import fr from '@/i18n/fr.json';

// Session
import { VueFire, VueFireAuth } from 'vuefire'
import { firebaseApp } from './firebase'

// Components
import DropDown from '@/components/generic/DropDown';
import DatePicker from '@/components/generic/DatePicker';
import WeekPicker from '@/components/generic/WeekPicker';
import PopperDropDown from '@/components/generic/PopperDropDown';
import Pagination from '@/components/generic/Pagination';
import Select from '@/components/generic/Select';
import BlogCard from '@/components/generic/BlogCard';
import Link from '@/components/generic/Link';
import Title from '@/components/generic/Title';
import TimeCounter from '@/components/generic/TimeCounter';
import Btn from '@/components/generic/Btn';
import Chips from '@/components/generic/Chips';
import Counter from '@/components/generic/Counter';
import Checkbox from '@/components/generic/Checkbox';
import DataTable from '@/components/generic/DataTable';
import Avatar from '@/components/generic/Avatar';
import Spinner from '@/components/generic/Spinner';
import Search from '@/components/generic/Search';
import Input from '@/components/generic/Input';
import SpinnerSpin from '@/components/generic/SpinnerSpin';
import Modal from '@/components/generic/Modal';
import Sidebar from '@/components/generic/Sidebar';
import WeekDays from '@/components/generic/WeekDays';
import Radio from '@/components/generic/Radio';
import AvatarSelect from '@/components/generic/AvatarSelect'

import InlineSvg from 'vue-inline-svg';
import '@/assets/styles/main.scss';
import('preline');

const app = createApp(App);
const pinia = createPinia();
const i18n = createI18n({
  legacy: false,
  locale: 'en',
  fallbackLocale: 'en',
  messages: { en, fr },
});

import { mask } from 'vue-the-mask';

app.use(i18n).use(pinia).use(store).use(router);
app.use(VueFire, { firebaseApp, modules: [VueFireAuth()] });
app.directive('mask', mask);

import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

app.component('VueDatePicker', VueDatePicker);
app.component('InlineSvg', InlineSvg);
app.component('GenericBlogCard', BlogCard);
app.component('GenericDropDown', DropDown);
app.component('GenericDatePicker', DatePicker);
app.component('GenericWeekPicker', WeekPicker);
app.component('GenericPopperDropDown', PopperDropDown);
app.component('GenericPagination', Pagination);
app.component('GenericSelect', Select);
app.component('GenericLink', Link);
app.component('GenericTitle', Title);
app.component('GenericTimeCounter', TimeCounter);
app.component('GenericBtn', Btn);
app.component('GenericChips', Chips);
app.component('GenericCounter', Counter);
app.component('GenericCheckbox', Checkbox);
app.component('GenericDataTable', DataTable);
app.component('GenericAvatar', Avatar);
app.component('GenericSearch', Search);
app.component('GenericInput', Input);
app.component('GenericSpinner', Spinner);
app.component('GenericSpinnerSpin', SpinnerSpin);
app.component('GenericModal', Modal);
app.component('GenericSidebar', Sidebar);
app.component('GenericWeekDays', WeekDays);
app.component('GenericRadio', Radio);
app.component('AvatarSelect', AvatarSelect);

app.mount('#app');
